export const BeslagType = {
    TRADITIONEEL: "traditioneel",
    OUDHOLLANDS: "Oudhollands",
    OTHER: "Anders:",
}

export const LuikType = {
    PANEELLUIK: "paneelluik",
    LOUVRELUIK: "Louvreluik",
    VLAKLUIK: "Vlak luik",
    VENSTERLUIK_VISIBLE_CLAMS: "Opgeklampt luik, klampen zichtbaar",
    VENSTERLUIK_INVISIBLE_CLAMS: "Opgeklampt luik, klampen niet zichtbaar",
    OTHER: "Anders:",
}

export const MontageType = {
    MUUR: "muur",
    KOZIJN: "kozijn",
}

export const DraaiType = {
    AL: "AL",
    AR: "AR",
    B: "B",
    CL: "CL",
    CR: "CR",
    DL: "DL",
    DR: "DR",
    E: "E",
    EL: "EL",
    ER: "ER",
    F: "F",
    FL: "FL",
    FR: "FR",
    ALO: "ALO",
    ARO: "ARO",
    BLO: "BLO",
    BRO: "BRO"
}

export const HengType = {
    T2: "T2",
    L2: "L2",
    H2: "H2",
    T3: "T3",
    L3: "L3",
    HT3: "HT3",
    LT3: "LT3",
}

export const Luiksluiting = {
    NO_CLOSING: "geen luiksluiting",
    TYPE_F: "type F",
    TYPE_A: "type A",
    TYPE_D: "type D",
    OUDHOLLANDS: "luiksluiting Oudhollands",
    TRADITIONEEL: "luiksluiting traditioneel",
    ENKEL: "enkele luiksluiting",
    MACO: "Maco",
    OTHER: "Anders:",
}

export const Luikvastzetter = {
    NO_FASTENER: "geen luikvastzetter",
    HERDERINNEKOPJE: "herderinnekopje",
    HOLLANDSE_LUIKWERVEL: "Hollandse luikwervel",
    LUIKWERVEL_MARSEILLE: "luikwervel Marseille",
    VERBORGEN_LUIKVASTZETTER: "verborgen luikvastzetter",
    COMFORT_ONDER_LUIKVASTZETTER: "comfort sluiting onder luik",
    VERBORGEN_LUIKVASTZETTER_MACO: "verborgen luikvastzetter Maco",
    AUTOMATISCHE_LUIKVASTZETTER_ZWART: "automatische luikvastzetter zwart",
    COMFORT_SLUITING: "comfort sluiting",
    OTHER: "Anders:",
}
